import { toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", {
  class: "md-ripple-wave md-ripple-leave md-ripple-leave-active",
  style: {"top":"-96.5px","left":"98.6562px","width":"229px","height":"229px"}
}, null, -1)
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"md-ripple\"><div class=\"md-button-content\"><i class=\"md-icon md-icon-font md-icon-image md-theme-default\"><svg height=\"24\" viewBox=\"0 0 24 24\" width=\"24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z\"></path><path d=\"M0 0h24v24H0z\" fill=\"none\"></path></svg></i></div></div>", 1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    tabindex: "0",
    class: "md-chip md-accent md-theme-default md-clickable md-focused",
    style: _normalizeStyle({
            background: _ctx.color ? `color:#${_ctx.color}` : ``,
        })
  }, [
    _createElementVNode("div", {
      class: "md-ripple",
      onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.selectContent && _ctx.selectContent(...args)), ["self"]))
    }, [
      (_ctx.name)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.selectContent && _ctx.selectContent(...args)), ["self"]))
          }, _toDisplayString(_ctx.name) + "     ", 1))
        : _createCommentVNode("", true),
      _hoisted_1,
      _createElementVNode("button", {
        type: "button",
        class: "md-button md-icon-button md-dense md-input-action md-clear md-theme-default",
        tabindex: "-1",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.deleteContent && _ctx.deleteContent(...args)))
      }, _hoisted_3)
    ])
  ], 4))
}